module.exports = __webpack_public_path__ + "img/teilen.85a61d24.svg";